<div class="fare-section" [ngClass]="{ upsell: isUpsell }">
  <h4 class="fare-title-wrapper">
    <span class="fare-title">{{ title }}</span>
    <span class="price">
      {{ fare.total.price | currency: fare.total.currency }}
      @if (travelRules) {
        <app-warning-tags
          class="upsell-wrapper"
          [iconId]="fare.uid"
          [ticket]="travelRules"
          [displayCheck]="false"
        ></app-warning-tags>
      }
    </span>
  </h4>
  <div class="flight-details">
    <div>
      <div class="cabin-class">
        {{ fare.outboundFlights[0].cabinClass | splitCamelCase | translate }}
        @if (fare.outboundFlights[0].additional.fareBrand?.name) {
          <span> ({{ fare.outboundFlights[0].additional.fareBrand?.name | titlecase }}) </span>
        }
      </div>
      <div class="flight-route">
        <!-- one way, dual in, dual out -->
        <app-flight-header
          class="flight-header-border"
          [flightJourney]="fare.outboundFlights[0]"
          [lastFlightJourney]="lastOutboundFlightJourney"
          [allJourneys]="fare.outboundFlights"
          [source]="fare.source"
          [duration]="fare.outboundTotalDuration"
          [preferred]="fare?.preferred"
          [preferenceLevel]="fare?.preferenceLevel"
          [preferredMessages]="fare?.preferredMessages"
          [tmcPreferredLogoUrl]="fare?.tmcPreferredLogoUrl"
          [searchType]="searchService.searches[ServiceType.Flight]?.chosenSearchType"
          [upsell]="true"
        >
        </app-flight-header>
        <!-- return -->
        @if (searchService.searches[ServiceType.Flight].isReturn && !isDualFlight) {
          <app-flight-header
            [flightJourney]="fare.inboundFlights[0]"
            [lastFlightJourney]="lastInboundFlightJourney"
            [allJourneys]="fare.inboundFlights"
            [source]="fare.source"
            [isReturn]="true"
            [duration]="fare.inboundTotalDuration"
            [searchType]="searchService.searches[ServiceType.Flight]?.chosenSearchType"
            [upsell]="true"
          >
          </app-flight-header>
        }
      </div>
    </div>

    <div>
      <dl class="fare-info">
        <div class="flex-row-container flex-row-container--center">
          <dt class="visuallyhidden">Fare Rules</dt>
          <dd>
            @if (!isAerLingus) {
              <a
                class="fare_rules_link"
                (click)="getFareRules(fare)"
                (keydown.enter)="getFareRules(fare)"
                tabindex="0"
                role="link"
              >
                <span i18n="@@ClicktoView">Click to View</span>
              </a>
            }
          </dd>
        </div>
        <!-- hangBaggage -->
        <div>
          <dt class="visuallyhidden">Carry-on Baggage</dt>
          <dd>
            @if (routeHappyResults?.data?.carryOnBag[0]?.description) {
              {{ routeHappyResults?.data.carryOnBag[0].description }}
            } @else {
              <span i18n="@@NotAvailable"> n/a </span>
            }

            @if (routeReturnHappyResults?.data?.carryOnBag[0]?.description) {
              <span class="visuallyhidden" i18n="@@flightLegReturn">Return</span>
              <span> / </span>
              {{ routeReturnHappyResults?.data.carryOnBag[0].description }}
            }
          </dd>
        </div>
        <!-- Checked Baggage -->
        <div>
          <dt class="visuallyhidden">Checked Baggage</dt>
          <dd>
            @if (routeHappyResults?.data?.checkedBag[0]?.description) {
              {{ routeHappyResults?.data.checkedBag[0].description }}
            } @else {
              <span i18n="@@NotAvailable"> n/a </span>
            }

            @if (routeReturnHappyResults?.data?.checkedBag[0]?.description) {
              <span class="visuallyhidden" i18n="@@flightLegReturn">Return</span>
              <span> / </span>
              {{ routeReturnHappyResults?.data.checkedBag[0].description }}
            }
          </dd>
        </div>
        <!-- changes -->
        <div>
          <dt class="visuallyhidden">Changes</dt>
          <dd>
            <app-ancillary-status-icon
              [isReturnFlight]="isReturnFlight"
              [ancillaryStatus]="transformedFareAncillaries[0].changes"
            >
            </app-ancillary-status-icon>
          </dd>
        </div>
        <!-- refund -->
        <div>
          <dt class="visuallyhidden">Refunds</dt>
          <dd>
            <app-ancillary-status-icon
              [isReturnFlight]="isReturnFlight"
              [ancillaryStatus]="transformedFareAncillaries[0].refund"
            >
            </app-ancillary-status-icon>
          </dd>
        </div>
        <!-- seat -->
        <div>
          <dt class="visuallyhidden">Seat</dt>
          <dd>
            @if (routeHappyResults?.data?.amenitySummary[0]?.seat) {
              {{ routeHappyResults.data.amenitySummary[0].seat.displayText }}
            } @else {
              <span i18n="@@NotAvailable"> n/a </span>
            }

            @if (routeReturnHappyResults?.data?.amenitySummary[0]?.seat) {
              <span class="visuallyhidden" i18n="@@flightLegReturn">Return</span>
              <span> / </span>
              {{ routeReturnHappyResults.data.amenitySummary[0].seat.displayText }}
            }
          </dd>
        </div>
        <!-- food -->
        <div>
          <dt class="visuallyhidden">Meal</dt>
          <dd>
            @if (routeHappyResults?.data?.amenitySummary[0]?.freshFood) {
              {{ routeHappyResults.data.amenitySummary[0].freshFood.displayText }}
            } @else {
              <span i18n="@@NotAvailable"> n/a </span>
            }

            @if (routeReturnHappyResults?.data?.amenitySummary[0]?.freshFood) {
              <span class="visuallyhidden" i18n="@@flightLegReturn">Return</span>
              <span> / </span>
              {{ routeReturnHappyResults.data.amenitySummary[0].freshFood.displayText }}
            }
          </dd>
        </div>
        <!-- wifi -->
        <div>
          <dt class="visuallyhidden">wifi</dt>
          <dd>
            @if (routeHappyResults?.data?.amenitySummary[0]?.wifi) {
              {{ routeHappyResults.data.amenitySummary[0].wifi.displayText }}
            } @else {
              <span i18n="@@NotAvailable"> n/a </span>
            }

            @if (routeReturnHappyResults?.data?.amenitySummary[0]?.wifi) {
              <span class="visuallyhidden" i18n="@@flightLegReturn">Return</span>
              <span> / </span>
              {{ routeReturnHappyResults.data.amenitySummary[0].wifi.displayText }}
            }
          </dd>
        </div>
      </dl>

      <div class="flex-row-container flex-row-container--center add-to-basket-wrapper">
        <button
          [disabled]="fare?.unavailable"
          type="button"
          appButton="small"
          (keydown.enter)="addToBasket(fare)"
          (keydown.space)="addToBasket(fare)"
          (click)="addToBasket(fare)"
        >
          {{ isUpsell ? 'Select Alternative' : 'Continue' }}
        </button>
      </div>
    </div>
  </div>
</div>
